/* Types */
import type { ReactNode } from 'react';
import type { SubstringMatch } from 'types/GooglePlacesTypes';

type PropsType = {
  text: string;
  matchedSubstrings: Array<SubstringMatch>;
};

const BoldMatchedSubstrings = ({ text, matchedSubstrings }: PropsType) => {
  const formattedTextArray: ReactNode[] = [];
  let chopped = 0;
  for (const { offset = 0, length } of matchedSubstrings) {
    const start = offset - chopped;
    if (start > 0) {
      formattedTextArray.push(text.substr(0, start));
    }
    formattedTextArray.push(<b key={text}>{text.substr(start, length)}</b>);
    chopped = start + length;
    text = text.substr(start + length);
  }
  if (text !== '') {
    formattedTextArray.push(text);
  }
  return <>{formattedTextArray}</>;
};

export default BoldMatchedSubstrings;
